/**
 * The description's HTML → plain text. open-api writes `text` as HTML (`Edited <b>Lobby.mp4</b>`);
 * staff-app renders it as TEXT, so no markup from a customer-controlled name can reach the DOM.
 * DOMParser documents are inert — scripts in them never run and images never load.
 */
export function htmlToText(html: string | null | undefined): string {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  // Their CONTENT is code, not description — textContent would otherwise print it.
  doc.querySelectorAll('script, style, noscript, template').forEach((el) => el.remove());
  return (doc.body.textContent ?? '').replace(/\s+/g, ' ').trim();
}
